/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Remove_SdhInputs */

const en_remove_sdh = /** @type {(inputs: Remove_SdhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove SDH`)
};

const fr_remove_sdh = /** @type {(inputs: Remove_SdhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer SDH`)
};

const de_remove_sdh = /** @type {(inputs: Remove_SdhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SDH entfernen`)
};

const it_remove_sdh = /** @type {(inputs: Remove_SdhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuovi SDH`)
};

const ru_remove_sdh = /** @type {(inputs: Remove_SdhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить SDH`)
};

const es_remove_sdh = /** @type {(inputs: Remove_SdhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar SDH`)
};

const zh_cn2_remove_sdh = /** @type {(inputs: Remove_SdhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`去除SDH`)
};

const ja_remove_sdh = /** @type {(inputs: Remove_SdhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SDHを削除する`)
};

const hi_remove_sdh = /** @type {(inputs: Remove_SdhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एसडीएच को हटाएँ`)
};

const pt_pt2_remove_sdh = /** @type {(inputs: Remove_SdhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover SDH`)
};

/**
* | output |
* | --- |
* | "Remove SDH" |
*
* @param {Remove_SdhInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const remove_sdh = /** @type {((inputs?: Remove_SdhInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Remove_SdhInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_remove_sdh(inputs)
	if (locale === "de") return de_remove_sdh(inputs)
	if (locale === "it") return it_remove_sdh(inputs)
	if (locale === "ru") return ru_remove_sdh(inputs)
	if (locale === "es") return es_remove_sdh(inputs)
	if (locale === "zh-CN") return zh_cn2_remove_sdh(inputs)
	if (locale === "ja") return ja_remove_sdh(inputs)
	if (locale === "hi") return hi_remove_sdh(inputs)
	if (locale === "pt-PT") return pt_pt2_remove_sdh(inputs)
	return en_remove_sdh(inputs)
});